export default __webpack_public_path__ + "static/cNDRnIyS-1c70f1831ea58bb56f21745ef88e5266.svg";